<template>
  <ContentWrapperControl
    no_bottom
    full_width
    class="h-screen bg-white flex flex-col items-center overflow-hidden z-poll papsi-poll pb-4"
  >
    <div
      class="bg-primary w-full flex flex-col items-center flex-shrink-0"
      style="height: 105px"
    >
      <div class="flex items-center w-full mt-4 px-3">
        <!-- <img
          src="@/assets/icons/papsi_arrow_back_alt.svg"
          alt="Back"
          class="w-5 h-5 cursor-pointer"
        /> -->

        <div class="flex-1 flex justify-center">
          <img :src="getLogoPath()" class="w-24" />
        </div>

        <div class="w-5"></div>
      </div>

      <div class="flex justify-center mt-4">
        <div
          v-for="n in 3"
          @click="index = n"
          :key="n"
          class="w-8 h-8 flex items-center justify-center rounded-full text-white font-bold"
          :class="[
            index === n ? 'bg-secondary-dark' : '',
            n !== 3 ? 'mr-3' : '',
          ]"
          :style="index === n ? '' : 'background-color: rgba(255,255,255,0.2)'"
        >
          {{ n }}
        </div>
        <!-- <div
          v-for="n in 3"
          :key="n"
          class="w-8 h-8 flex items-center justify-center rounded-full text-white font-bold"
          :class="[
            index === n ? 'bg-secondary-dark' : '',
            n !== 3 ? 'mr-3' : '',
          ]"
          :style="index === n ? '' : 'background-color: rgba(255,255,255,0.2)'"
        >
          {{ n }}
        </div> -->
      </div>
    </div>
    <div
      v-if="index === 1"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
      <div>
        <span class="font-bold text-primary text-left">{{
          this.lang("lbl_0000255")
        }}</span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="personal_info.lname"
            name="lname"
            :placeholder="lang('lbl_0000145')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="personal_info.fname"
            name="fname"
            :placeholder="lang('lbl_0000146')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.mname"
            name="mname"
            :placeholder="lang('lbl_0000325')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="personal_info.suffix"
            name="suffix"
            :placeholder="lang('lbl_0000385')"
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000386") }}
        </span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            name="id_type"
            :placeholder="lang('lbl_0000387')"
            :options="lookup.list_of_ids"
            v-model="id_info.id_type"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.id_number"
            name="id_number"
            :placeholder="lang('lbl_0000388')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            type="date"
            v-model="id_info.id_expiry"
            name="id_expiry"
            :placeholder="lang('lbl_0000389')"
            required
            expiry
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.tin"
            name="tin"
            :placeholder="lang('lbl_0000098')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            type="date"
            :birthday="true"
            v-model="id_info.date_of_birth"
            name="date_of_birth"
            :placeholder="lang('lbl_0000105')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.place_of_birth"
            name="place_of_birth"
            :placeholder="lang('lbl_0000390')"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000391')"
            name="nationality"
            :options="lookup.nationality"
            v-model="id_info.nationality"
            :required="!id_info.others"
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.others"
            name="others"
            :placeholder="lang('lbl_0000100') + ' ' + lang('lbl_0000392')"
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000401") }}
        </span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            name="country"
            :placeholder="lang('lbl_0000398')"
            :options="lookup.country"
            v-model="present_address.country"
            required
          />

          <template v-if="isPresentPhilippines">
            <ComboboxControl
              class="mb-4"
              name="province"
              :placeholder="lang('lbl_0000396')"
              :options="getProvinces"
              v-model="present_address.province"
              :loading="loading_provinces"
            />
          </template>

          <template v-else>
            <FormTextControl
              class="mb-4"
              v-model="present_address.province"
              name="province"
              :placeholder="lang('lbl_0000396')"
              uppercase
            />
          </template>

          <template v-if="isPresentPhilippines">
            <ComboboxControl
              class="mb-4"
              name="municipality"
              :placeholder="lang('lbl_0000397')"
              :options="getPresentCities"
              v-model="present_address.municipality"
              :loading="loading_cities"
              :disabled="!present_address.province || loading_cities"
            />
          </template>

          <template v-else>
            <FormTextControl
              class="mb-4"
              v-model="present_address.municipality"
              name="municipality"
              :placeholder="lang('lbl_0000397')"
              uppercase
            />
          </template>

          <template v-if="isPresentPhilippines">
            <ComboboxControl
              class="mb-4"
              name="barangay"
              :placeholder="lang('lbl_0000395')"
              :options="getPresentBarangays"
              v-model="present_address.barangay"
              :loading="loading_barangays"
              :disabled="!present_address.municipality || loading_barangays"
              required
            />
          </template>

          <template v-else>
            <FormTextControl
              class="mb-4"
              v-model="present_address.barangay"
              name="barangay"
              :placeholder="lang('lbl_0000395')"
              uppercase
            />
          </template>

          <FormTextControl
            class="mb-4"
            v-model="present_address.street"
            name="street"
            :placeholder="lang('lbl_0000394')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.house_no"
            name="house_no"
            :placeholder="lang('lbl_0000393')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.zip_code"
            name="zip_code"
            :placeholder="lang('lbl_0000399')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.years_of_residency"
            name="years_of_residency"
            :placeholder="lang('lbl_0000400')"
            required
            uppercase
            :numeric="true"
          />
        </div>
      </div>
      <div class="mt-4">
        <div class="flex items-center justify-between">
          <span class="font-bold text-primary text-left">
            {{ this.lang("lbl_0000402") }}
          </span>

          <label
            class="flex items-center gap-2 text-sm text-gray-600 cursor-pointer"
          >
            <input
              type="checkbox"
              v-model="same_as_present"
              class="cursor-pointer mr-2"
            />
            <span>{{ this.lang("lbl_0000510") }}</span>
          </label>
        </div>

        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            name="permanent_country"
            :placeholder="lang('lbl_0000398')"
            :options="lookup.country"
            v-model="permanent_address.country"
            :disabled="same_as_present"
          />

          <template v-if="isPermanentPhilippines">
            <ComboboxControl
              class="mb-4"
              name="permanent_province"
              :placeholder="lang('lbl_0000396')"
              :options="getProvinces"
              v-model="permanent_address.province"
              :loading="loading_provinces"
              :disabled="same_as_present"
            />
          </template>

          <template v-else>
            <FormTextControl
              class="mb-4"
              v-model="permanent_address.province"
              name="permanent_province"
              :placeholder="lang('lbl_0000396')"
              uppercase
              :disabled="same_as_present"
            />
          </template>

          <template v-if="isPermanentPhilippines">
            <ComboboxControl
              class="mb-4"
              name="permanent_municipality"
              :placeholder="lang('lbl_0000397')"
              :options="getPermanentCities"
              v-model="permanent_address.municipality"
              :loading="loading_cities"
              :disabled="
                !permanent_address.province || loading_cities || same_as_present
              "
            />
          </template>

          <template v-else>
            <FormTextControl
              class="mb-4"
              v-model="permanent_address.municipality"
              name="permanent_municipality"
              :placeholder="lang('lbl_0000397')"
              uppercase
              :disabled="same_as_present"
            />
          </template>

          <template v-if="isPermanentPhilippines">
            <ComboboxControl
              class="mb-4"
              name="permanent_barangay"
              :placeholder="lang('lbl_0000395')"
              :options="getPermanentBarangays"
              v-model="permanent_address.barangay"
              :loading="loading_barangays"
              :disabled="
                !permanent_address.municipality ||
                loading_barangays ||
                same_as_present
              "
              required
            />
          </template>

          <template v-else>
            <FormTextControl
              class="mb-4"
              v-model="permanent_address.barangay"
              name="permanent_barangay"
              :placeholder="lang('lbl_0000395')"
              uppercase
              :disabled="same_as_present"
            />
          </template>

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.street"
            name="permanent_street"
            :placeholder="lang('lbl_0000394')"
            uppercase
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.house_no"
            name="permanent_house_no"
            :placeholder="lang('lbl_0000393')"
            uppercase
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.zip_code"
            name="permanent_zip_code"
            :placeholder="lang('lbl_0000399')"
            uppercase
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.years_of_residency"
            name="permanent_years_of_residency"
            :placeholder="lang('lbl_0000400')"
            :numeric="true"
            uppercase
            :disabled="same_as_present"
          />
        </div>
      </div>
      <div class="flex flex-row mt-4">
        <ButtonControl class="flex-1 mr-2" :outline="true" @click="goBack">
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl
          class="flex-1 ml-2"
          @click="index = 2"
          :disabled="!isStep1Valid"
          >{{ this.lang("lbl_0000033") }}
        </ButtonControl>
      </div>
    </div>
    <div
      v-if="index === 2"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
      <div>
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000404") }}
        </span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="contact_information.telephone_number_format"
            name="telephone_number_format"
            :placeholder="lang('lbl_0000405')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="contact_information.social_media_account"
            name="social_media_account"
            :placeholder="lang('lbl_0000406')"
          />

          <div class="flex flex-row items-end mb-4">
            <FormTextControl
              class="flex-1"
              v-model="contact_information.mobile_number"
              name="mobile_number"
              :placeholder="lang('lbl_0000007')"
              required
              uppercase
              disabled
              type="mobile"
            />

            <button
              type="button"
              class="ml-2 px-4 py-3 rounded-lg text-sm font-bold uppercase shadow outline-none bg-success text-white"
              @click="$router.push('/settings/mobile')"
            >
              {{ lang("lbl_0000050") }}
            </button>
          </div>

          <div class="flex flex-row items-end mb-4">
            <FormTextControl
              class="flex-1"
              v-model="contact_information.email_address"
              name="email_address"
              :placeholder="lang('lbl_0000005')"
              disabled
              required
            />

            <button
              type="button"
              class="ml-2 px-4 py-3 rounded-lg text-sm font-bold uppercase shadow outline-none bg-success text-white"
              @click="$router.push('/settings/email')"
            >
              {{ lang("lbl_0000050") }}
            </button>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000407") }}
        </span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000408')"
            name="employment_status"
            :options="lookup.employment_status"
            v-model="employment_information.status"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="employment_information.others"
            name="others"
            :placeholder="lang('lbl_0000100') + ' ' + lang('lbl_0000392')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="employment_information.employer"
            name="employer"
            :placeholder="lang('lbl_0000409')"
            :required="employment_information.status === '01'"
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000410')"
            name="nature_of_work"
            :options="lookup.nature_of_work"
            v-model="employment_information.nature_of_work"
            :required="employment_information.status === '01'"
          />

          <FormTextControl
            class="mb-4"
            v-model="employment_information.other_work"
            name="other_work"
            :placeholder="lang('lbl_0000411')"
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            name="employment_country"
            :placeholder="lang('lbl_0000398')"
            :options="lookup.country"
            v-model="employment_information.country"
            :required="employment_information.status === '01'"
          />

          <template v-if="isEmploymentPhilippines">
            <ComboboxControl
              class="mb-4"
              name="employment_province"
              :placeholder="lang('lbl_0000396')"
              :options="getEmploymentProvinces"
              v-model="employment_information.province"
              :loading="loading_employment_provinces"
              :disabled="loading_employment_provinces"
              :required="employment_information.status === '01'"
            />

            <ComboboxControl
              class="mb-4"
              name="employment_municipality"
              :placeholder="lang('lbl_0000397')"
              :options="getEmploymentCities"
              v-model="employment_information.municipality"
              :loading="loading_employment_cities"
              :disabled="
                !employment_information.province || loading_employment_cities
              "
              :required="employment_information.status === '01'"
            />

            <ComboboxControl
              class="mb-4"
              name="employment_barangay"
              :placeholder="lang('lbl_0000395')"
              :options="lookup.barangays"
              v-model="employment_information.barangay"
              :loading="loading_barangays"
              :disabled="
                !employment_information.municipality || loading_barangays
              "
              :required="employment_information.status === '01'"
            />
          </template>

          <template v-else>
            <FormTextControl
              class="mb-4"
              name="employment_province"
              :placeholder="lang('lbl_0000396')"
              v-model="employment_information.province"
              :required="employment_information.status === '01'"
              uppercase
            />

            <FormTextControl
              class="mb-4"
              name="employment_municipality"
              :placeholder="lang('lbl_0000397')"
              v-model="employment_information.municipality"
              :required="employment_information.status === '01'"
              uppercase
            />

            <FormTextControl
              class="mb-4"
              name="employment_barangay"
              :placeholder="lang('lbl_0000395')"
              v-model="employment_information.barangay"
              :required="employment_information.status === '01'"
              uppercase
            />
          </template>

          <FormTextControl
            class="mb-4"
            v-model="employment_information.street"
            name="employment_street"
            :placeholder="lang('lbl_0000394')"
            :required="employment_information.status === '01'"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="employment_information.number"
            name="employment_number"
            :placeholder="lang('lbl_0000393')"
            :required="employment_information.status === '01'"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="employment_information.zip_code"
            name="employment_zip_code"
            :placeholder="lang('lbl_0000399')"
            :required="employment_information.status === '01'"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="employment_information.email_address"
            name="employment_email_address"
            :placeholder="lang('lbl_0000005')"
            :required="employment_information.status === '01'"
          />
        </div>
      </div>
      <div class="flex flex-row mt-4">
        <ButtonControl class="flex-1 mr-2" :outline="true" @click="goBack">
          {{ this.lang("lbl_0000181") }}
        </ButtonControl>

        <ButtonControl
          class="flex-1 ml-2"
          @click="index = 3"
          :disabled="!isStep2Valid"
          >{{ this.lang("lbl_0000033") }}
        </ButtonControl>
      </div>
    </div>
    <div
      v-if="index === 3"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
      <div>
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000412") }}
        </span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000413')"
            name="source_of_funds"
            :options="getSourceOfFunds"
            v-model="source_of_funds.source"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.others"
            name="others"
            :placeholder="lang('lbl_0000100') + ' ' + lang('lbl_0000392')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_1.name"
            name="remitter_1_name"
            :placeholder="lang('lbl_0000415')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_1.relationship"
            name="remitter_1_relationship"
            :placeholder="lang('lbl_0000416')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_2.name"
            name="remitter_2_name"
            :placeholder="lang('lbl_0000417')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_2.relationship"
            name="remitter_2_relationship"
            :placeholder="lang('lbl_0000418')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_3.name"
            name="remitter_3_name"
            :placeholder="lang('lbl_0000419')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_3.relationship"
            name="remitter_3_relationship"
            :placeholder="lang('lbl_0000420')"
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000421") }}
        </span>

        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000422')"
            name="is_person"
            :options="getUSFATCA"
            v-model="us_fatca.is_person"
            required
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000423')"
            name="civil_status"
            :options="getCivilStatus"
            v-model="us_fatca.civil_status"
            :disabled="disableUSFATCAFields"
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000104')"
            name="gender"
            :options="getGenders"
            v-model="us_fatca.gender"
            :disabled="disableUSFATCAFields"
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000424')"
            name="citizenship"
            :options="getCitizenship"
            v-model="us_fatca.citizenship"
            :disabled="disableUSFATCAFields"
          />

          <FormTextControl
            class="mb-4"
            v-model="us_fatca.others"
            name="others"
            :placeholder="lang('lbl_0000100') + ' ' + lang('lbl_0000392')"
            uppercase
            :disabled="disableUSFATCAFields"
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000425") }}
        </span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="mother_maiden_name.lname"
            name="lname"
            :placeholder="lang('lbl_0000426')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="mother_maiden_name.fname"
            name="fname"
            :placeholder="lang('lbl_0000427')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="mother_maiden_name.mname"
            name="mname"
            :placeholder="lang('lbl_0000428')"
            uppercase
          />
        </div>
      </div>

      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000429") }}
        </span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="spouse_info.lname"
            name="lname"
            :placeholder="lang('lbl_0000430')"
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="spouse_info.fname"
            name="fname"
            :placeholder="lang('lbl_0000431')"
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="spouse_info.mname"
            name="mname"
            :placeholder="lang('lbl_0000432')"
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="spouse_info.date_of_birth"
            name="date_of_birth"
            :placeholder="lang('lbl_0000433')"
            uppercase
            type="date"
          />

          <!-- <FormTextControl
            class="mb-4"
            v-model="spouse_info.occupation"
            name="occupation"
            :placeholder="lang('lbl_0000434')"
            uppercase
          /> -->

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000434')"
            name="occupation"
            :options="getOccupations"
            v-model="spouse_info.occupation"
          />
        </div>

        <label
          class="flex items-center text-sm text-gray-600 cursor-pointer mb-4"
        >
          <input
            type="checkbox"
            v-model="same_as_present_spouse"
            class="mr-2 cursor-pointer"
          />
          <span>{{ this.lang("lbl_0000509") }}</span>
        </label>

        <ComboboxControl
          class="mb-4"
          name="spouse_country"
          :placeholder="lang('lbl_0000398')"
          :options="lookup.country"
          v-model="spouse_info.country"
          :disabled="same_as_present_spouse"
        />

        <template v-if="isSpousePhilippines">
          <ComboboxControl
            class="mb-4"
            name="spouse_province"
            :placeholder="lang('lbl_0000396')"
            :options="getSpouseProvinces"
            v-model="spouse_info.province"
            :loading="loading_spouse_provinces"
            :disabled="
              same_as_present_spouse ||
              !isSpousePhilippines ||
              loading_spouse_provinces
            "
          />

          <ComboboxControl
            class="mb-4"
            name="spouse_municipality"
            :placeholder="lang('lbl_0000397')"
            :options="getSpouseCities"
            v-model="spouse_info.municipality"
            :loading="loading_spouse_cities"
            :disabled="
              same_as_present_spouse ||
              !spouse_info.province ||
              loading_spouse_cities
            "
          />
          <ComboboxControl
            class="mb-4"
            name="spouse_barangay"
            :placeholder="lang('lbl_0000395')"
            :options="getSpouseBarangays"
            v-model="spouse_info.barangay"
            :loading="loading_barangays"
            :disabled="same_as_present_spouse"
          />
        </template>

        <template v-else>
          <FormTextControl
            class="mb-4"
            v-model="spouse_info.province"
            name="spouse_province"
            :placeholder="lang('lbl_0000396')"
            uppercase
            :disabled="same_as_present_spouse"
          />

          <FormTextControl
            class="mb-4"
            v-model="spouse_info.municipality"
            name="spouse_municipality"
            :placeholder="lang('lbl_0000397')"
            uppercase
            :disabled="same_as_present_spouse"
          />

          <FormTextControl
            class="mb-4"
            v-model="spouse_info.barangay"
            name="spouse_barangay"
            :placeholder="lang('lbl_0000395')"
            uppercase
            :disabled="same_as_present_spouse"
          />
        </template>

        <FormTextControl
          class="mb-4"
          v-model="spouse_info.house_no"
          name="spouse_house_no"
          :placeholder="lang('lbl_0000393')"
          uppercase
          :disabled="same_as_present_spouse"
        />

        <FormTextControl
          class="mb-4"
          v-model="spouse_info.street"
          name="spouse_street"
          :placeholder="lang('lbl_0000394')"
          uppercase
          :disabled="same_as_present_spouse"
        />

        <FormTextControl
          class="mb-4"
          v-model="spouse_info.zip_code"
          name="spouse_zip_code"
          :placeholder="lang('lbl_0000399')"
          uppercase
          :disabled="same_as_present_spouse"
        />

        <div class="mt-4">
          <span class="font-bold text-primary text-left">
            {{ this.lang("lbl_0000511") }}
          </span>
          <div class="flex flex-col mt-4">
            <ComboboxControl
              required
              class="mb-4"
              :placeholder="lang('lbl_0000512')"
              name="pso"
              :options="getBranches"
              v-model="pso"
            />
          </div>
        </div>

        <div>
          <span class="font-semibold text-grey-darker">
            {{ this.lang("lbl_0000439") }}
          </span>

          <div class="flex flex-row mt-2">
            <div class="flex flex-col mr-4">
              <label class="flex flex-row items-center cursor-pointer">
                <input
                  type="checkbox"
                  v-model="products_services.credit_card"
                  class="mr-2"
                />
                <span>{{ this.lang("lbl_0000435") }}</span>
              </label>

              <label class="flex flex-row items-center cursor-pointer">
                <input
                  type="checkbox"
                  v-model="products_services.internet_banking"
                  class="mr-2"
                />
                <span>{{ this.lang("lbl_0000436") }}</span>
              </label>
            </div>

            <div class="flex flex-col">
              <label class="flex flex-row items-center cursor-pointer">
                <input
                  type="checkbox"
                  v-model="products_services.sme_loan"
                  class="mr-2"
                />
                <span>{{ this.lang("lbl_0000437") }}</span>
              </label>

              <label class="flex flex-row items-center cursor-pointer">
                <input
                  type="checkbox"
                  v-model="products_services.mobile_banking"
                  class="mr-2"
                />
                <span>{{ this.lang("lbl_0000438") }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row mt-6">
        <ButtonControl class="flex-1 mr-2" :outline="true" @click="goBack">
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl
          class="flex-1 ml-2"
          @click="submit()"
          :disabled="!isStep3Valid"
        >
          {{ this.lang("lbl_0000190") }}
        </ButtonControl>
      </div>
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import FormTextControl from "@/components/controls/FormTextControl.vue";
import ComboboxControl from "@/components/controls/ComboboxControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import BAO from "@/services/BAO";
import mixin from "@/mixin";

export default {
  mixins: [mixin],
  emits: [
    "success",
    "error",
    "alert",
    "login",
    "logout",
    "showloader",
    "hideloader",
    "showblinder",
    "hideblinder",
    "terminate",
    "checkauth",
    "nofooter",
    "shownavbar",
    "hidenavbar",
    "opensidebar",
    "closed",
    "agreed",
  ],
  components: {
    ContentWrapperControl,
    ComboboxControl,
    FormTextControl,
    ButtonControl,
  },
  watch: {
    same_as_present(val) {
      if (val) {
        this.copyPresentAddress();
      } else {
        this.clearPermanentAddress();
      }
    },

    same_as_present_spouse(val) {
      if (val) {
        this.copyPresentAddressToSpouse();
      } else {
        this.clearSpouseAddress();
      }
    },

    present_address: {
      handler() {
        if (this.same_as_present) {
          this.copyPresentAddress();
        }

        if (this.same_as_present_spouse) {
          this.copyPresentAddressToSpouse();
        }
      },
      deep: true,
    },

    async "present_address.country"(country) {
      this.present_address.province = "";
      this.present_address.municipality = "";
      this.present_address.barangay = "";

      this.lookup.provinces = [];
      this.lookup.present_cities = [];
      this.lookup.present_barangays = [];

      if (!country || country.toUpperCase() !== "PHILIPPINES") {
        return;
      }

      this.loading_provinces = true;

      try {
        const response = await BAO.getProvinces();

        this.lookup.provinces = response.data.data.map((province) => ({
          label: province.province_name,
          value: province.province_code,
        }));
      } finally {
        this.loading_provinces = false;
      }
    },

    async "present_address.province"(province_code) {
      if (!this.isPresentPhilippines || !province_code) {
        this.lookup.present_cities = [];
        return;
      }

      this.present_address.municipality = "";
      this.lookup.present_cities = [];

      this.loading_cities = true;

      try {
        const response = await BAO.getCities(province_code);

        this.lookup.present_cities = response.data.data.map((city) => ({
          label: city.city_name,
          value: city.city_code,
        }));
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        this.loading_cities = false;
      }
    },

    async "present_address.municipality"(city_code) {
      this.present_address.barangay = "";

      if (!this.isPresentPhilippines || !city_code) {
        this.lookup.present_barangays = [];
        return;
      }

      this.lookup.present_barangays = [];

      this.loading_barangays = true;

      try {
        const response = await BAO.getBarangays(city_code);

        this.lookup.present_barangays = response.data.data
          .sort((a, b) =>
            a.barangay_name.localeCompare(b.barangay_name, undefined, {
              numeric: true,
              sensitivity: "base",
            }),
          )
          .map((barangay) => ({
            label: barangay.barangay_name,
            value: barangay.barangay_code,
          }));
      } catch (error) {
        console.error("Error fetching barangays:", error);
      } finally {
        this.loading_barangays = false;
      }
    },

    async "permanent_address.country"(country) {
      if (!this.same_as_present) {
        this.permanent_address.province = "";
        this.permanent_address.municipality = "";
        this.permanent_address.barangay = "";
      }

      if (!this.same_as_present) {
        this.lookup.provinces = [];
      }
      this.lookup.permanent_cities = [];
      this.lookup.permanent_barangays = [];

      if (
        this.same_as_present &&
        country &&
        country.toUpperCase() === "PHILIPPINES"
      ) {
        this.lookup.permanent_cities = this.lookup.present_cities;
        this.lookup.permanent_barangays = this.lookup.present_barangays;
      }

      if (!country || country.toUpperCase() !== "PHILIPPINES") {
        return;
      }

      if (this.same_as_present) {
        return;
      }

      this.loading_provinces = true;

      try {
        const response = await BAO.getProvinces();

        this.lookup.provinces = response.data.data.map((province) => ({
          label: province.province_name,
          value: province.province_code,
        }));
      } finally {
        this.loading_provinces = false;
      }
    },

    async "permanent_address.province"(province_code) {
      if (!this.isPermanentPhilippines || !province_code) {
        this.lookup.permanent_cities = [];
        return;
      }

      if (this.same_as_present) {
        this.lookup.permanent_cities = this.lookup.present_cities;
        return;
      }

      if (!this.same_as_present) {
        this.permanent_address.municipality = "";
      }
      this.lookup.permanent_cities = [];

      this.loading_cities = true;

      try {
        const response = await BAO.getCities(province_code);

        this.lookup.permanent_cities = response.data.data.map((city) => ({
          label: city.city_name,
          value: city.city_code,
        }));
      } finally {
        this.loading_cities = false;
      }
    },

    async "permanent_address.municipality"(city_code) {
      if (this.same_as_present) {
        this.lookup.permanent_barangays = this.lookup.present_barangays;
        return;
      }

      if (!this.same_as_present) {
        this.permanent_address.barangay = "";
      }

      if (!city_code) {
        this.lookup.permanent_barangays = [];
        return;
      }

      this.lookup.permanent_barangays = [];

      this.loading_barangays = true;

      try {
        const response = await BAO.getBarangays(city_code);

        this.lookup.permanent_barangays = response.data.data
          .sort((a, b) =>
            a.barangay_name.localeCompare(b.barangay_name, undefined, {
              numeric: true,
              sensitivity: "base",
            }),
          )
          .map((barangay) => ({
            label: barangay.barangay_name,
            value: barangay.barangay_code,
          }));
      } finally {
        this.loading_barangays = false;
      }
    },

    async "employment_information.country"(country) {
      this.employment_information.province = "";
      this.employment_information.municipality = "";
      this.employment_information.barangay = "";

      this.lookup.employment_provinces = [];
      this.lookup.employment_cities = [];
      this.lookup.barangays = [];

      if (!country || country.toUpperCase() !== "PHILIPPINES") {
        return;
      }

      this.loading_employment_provinces = true;

      try {
        const response = await BAO.getProvinces();

        this.lookup.employment_provinces = response.data.data.map(
          (province) => ({
            label: province.province_name,
            value: province.province_code,
          }),
        );
      } finally {
        this.loading_employment_provinces = false;
      }
    },

    async "employment_information.province"(province_code) {
      if (!this.isEmploymentPhilippines || !province_code) {
        this.lookup.employment_cities = [];
        this.lookup.barangays = [];
        this.employment_information.barangay = "";
        return;
      }

      this.employment_information.municipality = "";
      this.employment_information.barangay = "";
      this.lookup.employment_cities = [];
      this.lookup.barangays = [];

      this.loading_employment_cities = true;

      try {
        const response = await BAO.getCities(province_code);

        this.lookup.employment_cities = response.data.data.map((city) => ({
          label: city.city_name,
          value: city.city_code,
        }));
      } finally {
        this.loading_employment_cities = false;
      }
    },

    async "employment_information.municipality"(city_code) {
      if (!this.isEmploymentPhilippines || !city_code) {
        this.lookup.barangays = [];
        this.employment_information.barangay = "";
        return;
      }

      this.employment_information.barangay = "";
      this.lookup.barangays = [];

      this.loading_barangays = true;

      try {
        const response = await BAO.getBarangays(city_code);

        this.lookup.barangays = response.data.data
          .sort((a, b) =>
            a.barangay_name.localeCompare(b.barangay_name, undefined, {
              numeric: true,
              sensitivity: "base",
            }),
          )
          .map((barangay) => ({
            label: barangay.barangay_name,
            value: barangay.barangay_code,
          }));
      } finally {
        this.loading_barangays = false;
      }
    },

    async "spouse_info.country"(country) {
      if (!this.same_as_present_spouse) {
        this.spouse_info.province = "";
        this.spouse_info.municipality = "";
        this.spouse_info.barangay = "";
      }

      this.lookup.spouse_provinces = [];
      this.lookup.spouse_cities = [];

      if (
        this.same_as_present_spouse &&
        country &&
        country.toUpperCase() === "PHILIPPINES"
      ) {
        this.lookup.spouse_provinces = this.lookup.provinces;
        this.lookup.spouse_cities = this.lookup.present_cities;
        this.lookup.spouse_barangays = this.lookup.present_barangays;
      }

      if (!country || country.toUpperCase() !== "PHILIPPINES") {
        return;
      }

      if (this.same_as_present_spouse) {
        return;
      }

      this.loading_spouse_provinces = true;

      try {
        const response = await BAO.getProvinces();

        this.lookup.spouse_provinces = response.data.data.map((province) => ({
          label: province.province_name,
          value: province.province_code,
        }));
      } finally {
        this.loading_spouse_provinces = false;
      }
    },

    async "spouse_info.province"(province_code) {
      if (!this.isSpousePhilippines || !province_code) {
        this.lookup.spouse_cities = [];
        return;
      }

      if (this.same_as_present_spouse) {
        this.lookup.spouse_cities = this.lookup.present_cities;
        return;
      }

      if (!this.same_as_present_spouse) {
        this.spouse_info.municipality = "";
      }
      this.lookup.spouse_cities = [];

      this.loading_spouse_cities = true;

      try {
        const response = await BAO.getCities(province_code);

        this.lookup.spouse_cities = response.data.data.map((city) => ({
          label: city.city_name,
          value: city.city_code,
        }));
      } finally {
        this.loading_spouse_cities = false;
      }
    },

    async "spouse_info.municipality"(city_code) {
      if (this.same_as_present_spouse) {
        this.lookup.spouse_barangays = this.lookup.present_barangays;
        return;
      }

      if (!this.same_as_present_spouse) {
        this.spouse_info.barangay = "";
      }

      if (!this.isSpousePhilippines || !city_code) {
        this.lookup.spouse_barangays = [];
        return;
      }

      this.lookup.spouse_barangays = [];

      this.loading_barangays = true;

      try {
        const response = await BAO.getBarangays(city_code);

        this.lookup.spouse_barangays = response.data.data
          .sort((a, b) =>
            a.barangay_name.localeCompare(b.barangay_name, undefined, {
              numeric: true,
              sensitivity: "base",
            }),
          )
          .map((barangay) => ({
            label: barangay.barangay_name,
            value: barangay.barangay_code,
          }));
      } finally {
        this.loading_barangays = false;
      }
    },
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("hidenavbar");
    this.$emit("nofooter", true);
    this.$emit("showloader");

    Promise.all([BAO.getRCBCInfo(), BAO.getBranches()])
      .then(([rcbc_response, branches_response]) => {
        // RCBC Info
        const data = rcbc_response.data.data;

        const mapToOption = (array) =>
          (array || []).map((value) => ({
            label: value,
            value: value,
          }));

        this.lookup.gender = mapToOption(data.gender);
        this.lookup.country = mapToOption(data.country);
        this.lookup.citizenship = mapToOption(data.citizenship);
        this.lookup.marital_status = mapToOption(data.marital_status);
        this.lookup.occupation = mapToOption(data.occupation);
        this.lookup.nature_of_work = mapToOption(data.nature_of_work_pnb);
        this.lookup.source_of_fund = mapToOption(data.source_of_fund);

        this.lookup.nationality = (data.nationality || []).map((item) => ({
          label: item.nationality,
          value: item.nationality,
          country: item.country,
        }));

        this.lookup.employment_status = data.employment_status.map(
          (employment_status) => ({
            label: employment_status.value,
            value: employment_status.key,
          }),
        );

        this.lookup.list_of_ids = data.list_of_ids.map((id) => ({
          label: id.bao_type,
          value: id.bao_code,
        }));

        this.lookup.are_you_us = data.are_you_us.map((us_fatca) => ({
          label: us_fatca.value,
          value: us_fatca.key,
        }));

        // Branches
        this.lookup.branches = branches_response.data.data.map((branch) => ({
          label: branch.name,
          value: branch.code,
        }));
      })
      .catch((error) => {
        console.error("Error loading lookup data:", error);
      })
      .finally(() => {
        this.$emit("hideloader");
      });
  },
  data() {
    return {
      index: 1,
      loading_provinces: false,
      loading_cities: false,
      loading_barangays: false,
      loading_employment_provinces: false,
      loading_employment_cities: false,
      loading_spouse_provinces: false,
      loading_spouse_cities: false,
      same_as_present_spouse: false,
      lookup: {
        branches: [],
        barangays: [],
        provinces: [],
        cities: [],
        present_cities: [],
        permanent_cities: [],
        present_barangays: [],
        permanent_barangays: [],
        spouse_barangays: [],
        country: [],
        nature_of_work: [],
        list_of_ids: [],
        employment_status: [],
        source_of_fund: [],
        are_you_us: [],
        citizenship: [],
        gender: [],
        marital_status: [],
        employment_provinces: [],
        employment_cities: [],
        spouse_provinces: [],
        spouse_cities: [],
      },
      personal_info: {
        fname: this.$store.state.info.first_name,
        mname: this.$store.state.info.middle_name,
        lname: this.$store.state.info.last_name,
        suffix: "",
      },
      id_info: {
        id_type: "",
        id_number: "",
        id_expiry: "",
        tin: this.$store.state.info.tin,
        date_of_birth: this.$store.state.info.date_of_birth,
        place_of_birth: "",
        nationality: "",
        others: "",
      },
      same_as_present: false,
      present_address: {
        house_no: "",
        street: "",
        barangay: "",
        municipality: "",
        province: "",
        country: "",
        zip_code: "",
        years_of_residency: "",
      },
      permanent_address: {
        house_no: "",
        street: "",
        barangay: "",
        municipality: "",
        province: "",
        country: "",
        zip_code: "",
        years_of_residency: "",
      },
      contact_information: {
        telephone_number_format: "",
        social_media_account: "",
        mobile_number: this.$store.state.info.mobile_no.startsWith("+63")
          ? this.$store.state.info.mobile_no.substring(3)
          : this.$store.state.info.mobile_no,
        email_address: this.$store.state.info.email,
      },
      employment_information: {
        status: "",
        others: "",
        employer: "",
        nature_of_work: "",
        other_work: "",
        number: "",
        street: "",
        barangay: "",
        province: "",
        municipality: "",
        country: "",
        zip_code: "",
        email_address: "",
      },
      source_of_funds: {
        source: "",
        others: "",
        average_monthly_amount: "",
        remitter_1: {
          name: "",
          relationship: "",
        },
        remitter_2: {
          name: "",
          relationship: "",
        },
        remitter_3: {
          name: "",
          relationship: "",
        },
      },
      us_fatca: {
        is_person: "",
        civil_status: "",
        gender: "",
        citizenship: "",
        others: "",
      },
      mother_maiden_name: {
        lname: "",
        fname: "",
        mname: "",
      },
      spouse_info: {
        lname: "",
        fname: "",
        mname: "",
        date_of_birth: "",
        occupation: "",
        number: "",
        street: "",
        barangay: "",
        province: "",
        municipality: "",
        country: "",
        zip_code: "",
      },
      products_services: {
        credit_card: false,
        internet_banking: false,
        sme_loan: false,
        mobile_banking: false,
      },
      pso: "",
    };
  },

  computed: {
    getBranches() {
      return this.lookup.branches || [];
    },

    getGenders() {
      return [
        { label: "Male", value: "M" },
        { label: "Female", value: "F" },
        { label: "Rather not say", value: "X" },
      ];
    },

    getProvinces() {
      return this.lookup.provinces || [];
    },

    getCities() {
      return this.lookup.cities || [];
    },

    getPresentCities() {
      return this.lookup.present_cities || [];
    },

    getPresentBarangays() {
      return this.lookup.present_barangays || [];
    },

    getSourceOfFunds() {
      return this.lookup.source_of_fund || [];
    },

    isPresentPhilippines() {
      return (
        this.present_address.country &&
        this.present_address.country.toUpperCase() === "PHILIPPINES"
      );
    },

    isPermanentPhilippines() {
      return (
        this.permanent_address.country &&
        this.permanent_address.country.toUpperCase() === "PHILIPPINES"
      );
    },

    getEmploymentProvinces() {
      return this.lookup.employment_provinces || [];
    },

    getEmploymentCities() {
      return this.lookup.employment_cities || [];
    },

    getPermanentCities() {
      return this.lookup.permanent_cities || [];
    },

    getPermanentBarangays() {
      return this.lookup.permanent_barangays || [];
    },

    getSpouseBarangays() {
      return this.lookup.spouse_barangays || [];
    },

    getUSFATCA() {
      return this.lookup.are_you_us || [];
    },

    disableUSFATCAFields() {
      return this.us_fatca.is_person !== "2";
    },

    getCitizenship() {
      return this.lookup.citizenship || [];
    },

    getOccupations() {
      return this.lookup.occupation || [];
    },

    getCivilStatus() {
      return this.lookup.marital_status || [];
    },

    isEmploymentPhilippines() {
      return (
        this.employment_information.country &&
        this.employment_information.country.toUpperCase() === "PHILIPPINES"
      );
    },

    getSpouseProvinces() {
      return this.lookup.spouse_provinces || [];
    },

    getSpouseCities() {
      return this.lookup.spouse_cities || [];
    },

    isSpousePhilippines() {
      return (
        this.spouse_info.country &&
        this.spouse_info.country.toUpperCase() === "PHILIPPINES"
      );
    },

    isStep1Valid() {
      return (
        this.personal_info.lname &&
        this.personal_info.fname &&
        this.id_info.id_type &&
        this.id_info.id_number &&
        this.id_info.id_expiry &&
        this.id_info.tin &&
        this.id_info.date_of_birth &&
        this.id_info.place_of_birth &&
        (this.id_info.nationality || this.id_info.others?.trim()) &&
        this.present_address.country &&
        this.present_address.barangay &&
        this.present_address.street &&
        this.present_address.house_no &&
        this.present_address.zip_code &&
        this.present_address.years_of_residency &&
        (!this.isPresentPhilippines ||
          (this.present_address.province && this.present_address.municipality))
      );
    },

    isStep2Valid() {
      const employed = this.employment_information.status === "01";

      return (
        this.contact_information.telephone_number_format &&
        this.contact_information.mobile_number &&
        this.contact_information.email_address &&
        this.employment_information.status &&
        (!employed ||
          (this.employment_information.employer &&
            this.employment_information.nature_of_work &&
            this.employment_information.country &&
            this.employment_information.street &&
            this.employment_information.barangay &&
            this.employment_information.zip_code &&
            this.employment_information.email_address &&
            (!this.isEmploymentPhilippines ||
              (this.employment_information.province &&
                this.employment_information.municipality))))
      );
    },

    isStep3Valid() {
      return (
        this.source_of_funds.source &&
        this.us_fatca.is_person &&
        (this.disableUSFATCAFields ||
          (this.us_fatca.civil_status &&
            this.us_fatca.gender &&
            this.us_fatca.citizenship)) &&
        this.mother_maiden_name.lname &&
        this.mother_maiden_name.fname &&
        this.pso
      );
    },
  },
  methods: {
    getLogoPath() {
      const path = "ga/";
      const file_name = "papsi_logo.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },

    goBack() {
      if (this.index > 1) {
        this.index--;
        return;
      }

      this.index = 1;

      this.personal_info = {
        fname: "",
        mname: "",
        lname: "",
        suffix: "",
      };

      this.id_info = {
        id_type: "",
        id_number: "",
        id_expiry: "",
        tin: "",
        date_of_birth: "",
        place_of_birth: "",
        nationality: "",
        others: "",
      };

      this.same_as_present = false;

      this.present_address = {
        house_no: "",
        street: "",
        barangay: "",
        municipality: "",
        province: "",
        country: "",
        zip_code: "",
        years_of_residency: "",
      };

      this.permanent_address = {
        house_no: "",
        street: "",
        barangay: "",
        municipality: "",
        province: "",
        country: "",
        zip_code: "",
        years_of_residency: "",
      };

      this.contact_information = {
        telephone_number_format: "",
        social_media_account: "",
        mobile_number: "",
        email_address: "",
      };

      this.employment_information = {
        status: "",
        others: "",
        employer: "",
        nature_of_work: "",
        other_work: "",
        number: "",
        street: "",
        barangay: "",
        province: "",
        municipality: "",
        country: "",
        zip_code: "",
        email_address: "",
      };

      this.source_of_funds = {
        source: "",
        others: "",
        average_monthly_amount: "",
        remitter_1: {
          name: "",
          relationship: "",
        },
        remitter_2: {
          name: "",
          relationship: "",
        },
        remitter_3: {
          name: "",
          relationship: "",
        },
      };

      this.us_fatca = {
        is_person: "",
        civil_status: "",
        gender: "",
        citizenship: "",
        others: "",
      };

      this.mother_maiden_name = {
        lname: "",
        fname: "",
        mname: "",
      };

      this.spouse_info = {
        lname: "",
        fname: "",
        mname: "",
        date_of_birth: "",
        occupation: "",
        number: "",
        street: "",
        barangay: "",
        province: "",
        municipality: "",
        country: "",
        zip_code: "",
      };

      this.products_services = {
        credit_card: false,
        internet_banking: false,
        sme_loan: false,
        mobile_banking: false,
      };

      this.lookup.cities = [];
      this.lookup.present_cities = [];
      this.lookup.present_barangays = [];
      this.lookup.barangays = [];
      this.lookup.permanent_cities = [];
      this.lookup.permanent_barangays = [];
      this.lookup.provinces = [];
      this.lookup.employment_cities = [];
      this.lookup.employment_provinces = [];
      this.lookup.spouse_cities = [];
      this.lookup.spouse_barangays = [];
      this.lookup.spouse_provinces = [];

      this.$router.push("/dashboard");
    },

    async submit() {
      const int_products = [
        this.products_services.credit_card ? "1" : "0",
        this.products_services.sme_loan ? "1" : "0",
        this.products_services.internet_banking ? "1" : "0",
        this.products_services.mobile_banking ? "1" : "0",
      ].join("");

      const payload = {
        // Personal Information
        account_no: this.$store.state.info.account_no,
        member_key: this.$store.state.key,
        first_name: this.personal_info.fname,
        middle_name: this.personal_info.mname,
        last_name: this.personal_info.lname,
        suffix: this.personal_info.suffix,

        // ID Presented
        id_code: this.id_info.id_type,
        id_number: this.id_info.id_number,
        id_expiry: this.id_info.id_expiry,
        tin: this.id_info.tin,
        birth_date: this.id_info.date_of_birth,
        birth_place: this.id_info.place_of_birth,
        nationality: this.id_info.nationality,
        nationality_other: this.id_info.others,

        // Present Address
        house_no: this.present_address.house_no,
        street: this.present_address.street,
        brgy: this.present_address.barangay,
        province: this.present_address.province,
        municipality: this.present_address.municipality,
        country: this.present_address.country,
        zip_code: this.present_address.zip_code,
        residence: this.present_address.years_of_residency,
        ad_same: this.same_as_present,

        // Permanent Address
        per_house_no: this.permanent_address.house_no,
        per_street: this.permanent_address.street,
        per_brgy: this.permanent_address.barangay,
        per_province: this.permanent_address.province,
        per_municipality: this.permanent_address.municipality,
        per_country: this.permanent_address.country,
        per_zip_code: this.permanent_address.zip_code,
        per_residence: this.permanent_address.years_of_residency,

        // Contact Information
        telephone_no: this.contact_information.telephone_number_format,
        social_media: this.contact_information.social_media_account,
        mobile_no: this.contact_information.mobile_number,
        email: this.contact_information.email_address,

        // Employment Information
        emp_type: this.employment_information.status,
        emp_type_others: this.employment_information.others,
        emp_name: this.employment_information.employer,
        nature_of_work: this.employment_information.nature_of_work,
        work_oth: this.employment_information.other_work,
        emp_no: this.employment_information.number,
        emp_street: this.employment_information.street,
        emp_brgy: this.employment_information.barangay,
        emp_province: this.employment_information.province,
        emp_municipality: this.employment_information.municipality,
        emp_country: this.employment_information.country,
        emp_zipcode: this.employment_information.zip_code,
        emp_email: this.employment_information.email_address,

        // Source of Funds
        src_fund: this.source_of_funds.source,
        src_others: this.source_of_funds.others,
        src_amount: this.source_of_funds.average_monthly_amount,
        rem1_name: this.source_of_funds.remitter_1.name,
        rem1_relationship: this.source_of_funds.remitter_1.relationship,
        rem2_name: this.source_of_funds.remitter_2.name,
        rem2_relationship: this.source_of_funds.remitter_2.relationship,
        rem3_name: this.source_of_funds.remitter_3.name,
        rem3_relationship: this.source_of_funds.remitter_3.relationship,

        // US FATCA
        us_citizen: this.us_fatca.is_person,
        civil_status: this.us_fatca.civil_status,
        gender: this.us_fatca.gender,
        citizenship: this.us_fatca.citizenship,
        us_others: this.us_fatca.others,

        // Mother's Maiden Name
        mother_last_name: this.mother_maiden_name.lname,
        mother_first_name: this.mother_maiden_name.fname,
        mother_middle_name: this.mother_maiden_name.mname,

        // Spouse Information
        sp_last_name: this.spouse_info.lname,
        sp_first_name: this.spouse_info.fname,
        sp_middle_name: this.spouse_info.mname,
        sp_birth_date: this.spouse_info.date_of_birth,
        sp_occupation: this.spouse_info.occupation,
        sp_no: this.spouse_info.house_no,
        sp_house: this.spouse_info.house_no,
        sp_street: this.spouse_info.street,
        sp_brgy: this.spouse_info.barangay,
        sp_province: this.spouse_info.province,
        sp_municipality: this.spouse_info.municipality,
        sp_country: this.spouse_info.country,
        sp_zip_code: this.spouse_info.zip_code,
        sp_same: this.same_as_present_spouse,

        branch_code: this.pso,
        int_products,
      };

      this.$emit("showloader");

      try {
        const response = await BAO.submitPNB(payload);
        if (response.data.success) {
          this.$emit("success", "Application submitted successfully");
        } else {
          this.$emit("error", "Failed to submit application");
        }
      } catch (error) {
        this.$emit(
          "error",
          error.response?.data?.message || "Failed to submit application",
        );
      } finally {
        this.$emit("hideloader");
        this.$router.push("/dashboard");
      }
    },

    clearPermanentAddress() {
      this.permanent_address = {
        house_no: "",
        street: "",
        barangay: "",
        municipality: "",
        province: "",
        country: "",
        zip_code: "",
        years_of_residency: "",
      };
    },

    clearSpouseAddress() {
      this.spouse_info = {
        ...this.spouse_info,
        house_no: "",
        street: "",
        barangay: "",
        municipality: "",
        province: "",
        country: "",
        zip_code: "",
      };
    },

    copyPresentAddress() {
      this.permanent_address = {
        ...this.present_address,
      };

      // console.log(this.permanent_address);
      // console.log(this.present_address);
    },

    copyPresentAddressToSpouse() {
      this.spouse_info = {
        ...this.spouse_info,

        house_no: this.present_address.house_no,
        street: this.present_address.street,
        barangay: this.present_address.barangay,
        municipality: this.present_address.municipality,
        province: this.present_address.province,
        country: this.present_address.country,
        zip_code: this.present_address.zip_code,
      };
    },
  },
};
</script>

<style scoped>
.bg-white-20 {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
